/* eslint no-eval: 0 */

import { FeesClientHelper } from "./FeesClientHelper.js"
import { I18N } from "./I18N.js"
import { Image } from "./lib/Image.js"
import { OpeningHourHelper } from "./OpeningHourHelper.js"
import { Spinner } from "./Spinner.js"
import { StoreOfflineDialog } from "./StoreOfflineDialog.js"
import { StoreSearch } from "./StoreSearch.js"
import { Toast } from "./Toast.js"

export class Stores {
	_target
	_getStoresPromise
	_appContext
	_storeSearch
	_onSelectStoreHandlers = []

	createGetStoresPromise = () => {
		this._getStoresPromise = new Promise((resolve, reject) => {
			fetch('/crm/stores', {
				method: 'GET'
			})
				.then(storesResp => storesResp.json()
					.then(stores => {
						if (!Array.isArray(stores)) {
							console.warn('/crm/stores returned non-array:', stores)
							return resolve([])
						}
						return resolve(stores
							.filter(s => s.isActive)
							.sort((s1, s2) => s1.pos - s2.pos))
					})
				)
				.catch(e => {
					console.error('Failed to fetch stores:', e)
					reject(e)
				})
		})
	}

	getStoresPromise = () => this._getStoresPromise

	constructor(target) {
		this._target = document.getElementById(target)
		this._target.innerHTML = `
			<h2 i18n>Stores</h2>
			<div id="storeSearch"></div>
			<div id="storesList" class="businessCards"></div>
		`
		I18N.translateElement(this._target)
		this._storeSearch = new StoreSearch('storeSearch')
		const spinner = new Spinner(this._target, 15)
		this.createGetStoresPromise()
		this.getStoresPromise()
			.then(stores => {
				console.debug(stores)
				const html = stores.map(s => {
					const addressUrlParams = `${s.address.street} ${s.address.nr}, ${s.address.postalCode} ${s.address.city}, ${s.address.country}`
					return `<div id="stores${s.id}card" class="card clickable selectable">
							${s.imageUrl ? Image.insert(s.imageUrl, s.name + '_img', ['image'], null, false) : ''}
							${s.logoUrl ? Image.insert(s.logoUrl, s.name + '_logo', ['logo'], null, true) : `<h3>${s.name}</h3>`}
							<h3>${s.foodStyle ? s.foodStyle : ''}</h3>
							<div><a href="https://www.openstreetmap.org/search?query=${encodeURIComponent(addressUrlParams)}&xhr=1" target="_blank">${s.address.street} ${s.address.nr}, ${s.address.postalCode} ${s.address.city}</a></div>
							<div><span i18n>Pickup</span>: ${s.openingHours.map(o => `${o.fromDay ? I18N.translate(o.fromDay) : ''}${o.toDay && o.toDay !== o.fromDay ? ` - ${I18N.translate(o.toDay)}` : ''} ${o.openingHour ? o.openingHour : ''}${o.closingHour ? `${!o.openingHour ? ` ${I18N.translate('until')} ` : ' - '}${o.closingHour}` : ''}${o.closed ? ` ${I18N.translate('closed')} ` : ''}<br>`).join('')}</div>
							${s.deliverer ? `<div><span i18n>Delivery</span>: ${s.deliverer.openingHours.map(o => `${o.fromDay ? I18N.translate(o.fromDay) : ''}${o.toDay && o.toDay !== o.fromDay ? ` - ${I18N.translate(o.toDay)}` : ''} ${o.openingHour ? o.openingHour : ''}${o.closingHour ? `${!o.openingHour ? ` ${I18N.translate('until')} ` : ' - '}${o.closingHour}` : ''}${o.closed ? ` ${I18N.translate('closed')} ` : ''}<br>`).join('')}</div>` : ''}
							<div class="storeClosed badge opening" hidden i18n>closed </div>
							<div class="onlyPickup badge opening" ${s.deliverer ? 'hidden' : ''} i18n>only delivery</div>
							<div class="storeOffline badge opening" hidden i18n>Offline</div>
							${s.deliverer ? this._getDeliveryDistancesHtml(s.deliverer.calcDeliveryDistance, s.deliverer.calcDeliveryFee) : ''}
							
						</div>`
				}).join('')
				const storesList = document.getElementById('storesList')
				storesList.innerHTML = html
				I18N.translateElement(storesList)
				const now = new Date()
				if (!OpeningHourHelper.areStoresOpen(stores, false, now, false) && !OpeningHourHelper.areStoresOpen(stores, true, now, false)) {
					new Toast('toaster', I18N.translate('All stores are currently closed. You can only schedule your order.'), Toast.INFO, 7)
				}
				stores.forEach(s => {
					const card = document.getElementById(`stores${s.id}card`)
					// Add click handlers to card
					card.addEventListener('click', ev => {
						if (['A', 'SUMMARY'].includes(ev.target.tagName)) {
							return
						}
						Array.from(ev.currentTarget.parentElement.children).forEach(c => c.removeAttribute('selected'))
						ev.currentTarget.setAttribute('selected', '')
						console.debug('Selected store: ', s)
						if (OpeningHourHelper.isOpen(new Date(), s.openingHours) && s.wsOnline === false) {
							new StoreOfflineDialog('storeOfflineDialog', s).setVisible(true)
						}
						this._onSelectStoreHandlers.forEach(handler => handler(s))
						this._appContext.setActive('products', null, s.name)
					})
				})
				this._updateOpeningState()
				this._pollWsOnlineState()
				setInterval(this._pollWsOnlineState, 15 * 1000)
				setInterval(this._updateOpeningState, 5 * 60 * 1000)
				this._storeSearch.setStores(stores)
				this._storeSearch.addOnSetFilterHandlers(this.setFilter)
				spinner.dismiss()
				// Auto-select store from URL on page reload
				const pendingName = this._appContext._pendingStoreName
				if (pendingName) {
					this._appContext._pendingStoreName = null
					const pendingStore = stores.find(s => s.name === pendingName)
					if (pendingStore) {
						const card = document.getElementById(`stores${pendingStore.id}card`)
						if (card) card.setAttribute('selected', '')
						this._onSelectStoreHandlers.forEach(handler => handler(pendingStore))
					} else {
						this._appContext.setActive('stores')
					}
				}
			})
	}

	setFilter = filter => {
		console.log('New filter:', filter)
		this._getStoresPromise
			.then(stores => {
				stores.forEach(s => {
					const storeCard = document.getElementById(`stores${s.id}card`)
					if (storeCard) {
						let open = true
						if (filter) {
							if (!OpeningHourHelper.areStoresOpen([s], Boolean(filter.deliveryAddress), filter.schedule.date, filter.schedule.now !== true)) {
								open = false
							}
							if (open && filter.deliveryAddress) {
								if (!s.deliverer) {
									storeCard.setAttribute('disabled', '')
									return
								}
								FeesClientHelper.getTour(s.address, filter.deliveryAddress)
									.then(tour => {
										console.log('Tour from :', s.name, tour)
										const maxDistanceKm = this._getDeliveryDistance(filter.expectedValueOver ? filter.expectedValueOver : 10, s.deliverer.calcDeliveryDistance)
										if (tour.distance > maxDistanceKm) {
											storeCard.setAttribute('disabled', '')
										}
									})
									.catch(e => {
										if (e === 'OUT_OF_DELIVERY_AREA') {
											storeCard.setAttribute('disabled', '')
										}
										else {
											console.warn(e)
										}
									})
							}
						}
						if (open) {
							storeCard.removeAttribute('disabled')
						}
						else {
							storeCard.setAttribute('disabled', '')
						}
					}
				})
			})
	}

	setAppContext = appContext => this._appContext = appContext

	addOnStoreSelectedHandlers = (...onSelectStoreHandlers) => this._onSelectStoreHandlers.push(...onSelectStoreHandlers)

	setVisible = visible => {
		if (visible) {
			this._target.removeAttribute('hidden')
		}
		else {
			this._target.setAttribute('hidden', '')
		}
		this._getStoresPromise
			.then(() => this._storeSearch.setVisible(visible))
	}

	_updateOpeningState = () => {
		this._getStoresPromise
			.then(stores => {
				stores.forEach(s => {
					const card = document.getElementById(`stores${s.id}card`)
					const now = new Date()
					if (!OpeningHourHelper.isOpen(now, s.openingHours)) {
						card.querySelector('.storeClosed').removeAttribute('hidden')
						card.querySelector('.onlyPickup').setAttribute('hidden', '')
					}
					else {
						card.querySelector('.storeClosed').setAttribute('hidden', '')
						if (!s.deliverer || !OpeningHourHelper.isOpen(now, s.deliverer.openingHours)) {
							card.querySelector('.onlyPickup').removeAttribute('hidden')
						}
						else {
							card.querySelector('.onlyPickup').setAttribute('hidden', '')
						}
					}
				})
			})
			.then(() => this._updateOfflineBadges())
	}

	_updateOfflineBadges = () => {
		this._getStoresPromise
			.then(stores => {
				stores.forEach(s => {
					const card = document.getElementById(`stores${s.id}card`)
					if (!card) return
					const now = new Date()
					const offline = OpeningHourHelper.isOpen(now, s.openingHours) && s.wsOnline === false
					const badge = card.querySelector('.storeOffline')
					if (offline) {
						badge.removeAttribute('hidden')
					}
					else {
						badge.setAttribute('hidden', '')
					}
				})
			})
	}

	_pollWsOnlineState = () => {
		fetch('/crm/stores')
			.then(res => res.json())
			.then(freshStores => {
				if (!Array.isArray(freshStores)) return
				this._getStoresPromise.then(stores => {
					stores.forEach(s => {
						const fresh = freshStores.find(fs => fs.id === s.id)
						if (fresh) {
							s.wsOnline = fresh.wsOnline
						}
					})
					this._updateOfflineBadges()
				})
			})
			.catch(e => console.warn('Failed to poll wsOnline state:', e))
	}

	_getDeliveryDistancesHtml = (calcDeliveryDistance, calcDeliveryFee) => {
		const values = [10, 30, 50]
		const feeDistances = [1, 2, 4.2, 5]
		const distances = []
		const fees = []
		values.forEach(value => {
			const newDistance = this._getDeliveryDistance(value, calcDeliveryDistance)
			if (!distances.some(d => d.distance === newDistance)) {
				distances.push({ value: value, distance: newDistance })
			}
			feeDistances.forEach(d => {
				if (newDistance >= d) {
					const newFee = this._getFee(value, d, calcDeliveryFee)
					// console.debug(`Fee for ${d}km and a value of ${value}€ is ${newFee}€`)
					fees.push({ value: value, distance: d, fee: newFee })
				}
			})
		})
		let html = '<details class="smallFont">'
		html += `<summary>${I18N.translate('Delivery Terms')}</summary>`
		distances.filter(d => d.distance > 0).forEach(d => html += `<div class="storeDeliveryDistance">${I18N.translateAndFormat('Delivery distance from {0}€ order value is {1}km', d.value, d.distance)}</div>`)
		const relevantFees = new Set()
		fees
			.sort((a, b) => (a.value - b.value) * 1000000 - (a.distance - b.distance) * 1000 + (a.fee - b.fee))
			.filter(f => {
				const group = `${f.value}|${f.fee}`
				if (relevantFees.has(group)) {
					return false
				}
				else {
					relevantFees.add(group)
					return true
				}
			})
			.sort((a, b) => (a.value - b.value) * 1000000 - (a.distance - b.distance) + (a.fee - b.fee) * 1000)
			.forEach(f => html += `<div class="storeDeliveryFee">${I18N.translateAndFormat('Delivery fee from {0}€ order value up to {1}km is {2}€', f.value, f.distance, f.fee)}</div>`)
		html += '</details>'
		return html
	}

	_getDeliveryDistance = (amount, calcDeliveryDistance) => eval(calcDeliveryDistance)

	_getFee = (amount, distance, calcDeliveryFee) => eval(calcDeliveryFee)

}